import { IQuoteImageBlock } from '@models/IQuoteImageBlock';
import SiteEnum from '@models/enums/SiteEnum';
import SharedQuoteImageBlock from '@organisms/QuoteImageBlock/QuoteImageBlock';

const QuoteImageBlock = (props: IQuoteImageBlock) => (
  <div className="tw-component-margin">
    <SharedQuoteImageBlock {...props} site={SiteEnum.B2B} />
  </div>
);

export default QuoteImageBlock;
